import React, { useCallback, useState } from 'react';
import styled from 'styled-components';
import { color, space, fontSize } from '@core-ds/primitives';
import MenuItem from '../links/menu_item';
import StoreSelector from './store/store_selector';

export const Title = styled.a`
   color: ${color.white};
   display: flex;
   align-items: center;
   font-size: ${fontSize[1]};
   font-weight: bold;
   margin: ${space[0]};
   padding: ${space[4]} ${space[5]};

   :hover {
      text-decoration: none;
   }
`;

export const Menu = styled.div`
   position: absolute;
   display: none;
   left: 0;
   top: 100%;
   background: ${color.gray8};
`;

const HeadingContainer = styled.li`
   display: flex;
   align-items: stretch;
   max-width: 236px;

   :hover,
   &.js-menu-is-open {
      background: ${color.gray8};
      cursor: pointer;
      z-index: 1;
   }

   :focus {
      outline: none;
   }

   ${({ dropdownOpen }) =>
      dropdownOpen
         ? ''
         : `
            :hover,
            &.js-menu-is-open {
               ${Menu} {
                  display: flex;
               }
            }`}

   :hover {
      ${Menu} {
         z-index: 1;
      }
   }
`;

const Heading = ({ info, isActive, headingOpened, stores }) => {
   const [dropdownOpen, setDropdownOpen] = useState(false);

   const keyPressed = useCallback(
      e => {
         if (e.key === 'Enter') {
            headingOpened(info.title);
         }
      },
      [headingOpened]
   );

   return (
      <HeadingContainer
         tabIndex={0}
         onKeyDown={keyPressed}
         className={isActive && 'js-menu-is-open'}
         dropdownOpen={dropdownOpen}
      >
         <Title>{info.title}</Title>
         {info.hasStoreDropdown && (
            <StoreSelector stores={stores} dropdownState={[dropdownOpen, setDropdownOpen]} />
         )}
         {info.sublinks && (
            <Menu>
               {info.sublinks.map(
                  sublink =>
                     sublink.disabled || <MenuItem key={`${sublink.title}-sublink`} {...sublink} />
               )}
            </Menu>
         )}
      </HeadingContainer>
   );
};

export default Heading;
